import { render } from "./DashboardMain.vue?vue&type=template&id=9c1daff4&ts=true"
import script from "./DashboardMain.vue?vue&type=script&lang=ts"
export * from "./DashboardMain.vue?vue&type=script&lang=ts"

import "./DashboardMain.vue?vue&type=style&index=0&id=9c1daff4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__